import { i18n } from '../../../i18n-handler/handler/i18n';
import { IStepList } from '../../../interfaces/account/IStepList';
import { DocumentValidationStatus } from '../../../interfaces/profile/IProfileExtra';

let lang = 'fr';

const getExtraValidationSteps = (
    validationStep: number,
    params: {
        kycInfo: {
            identityProof: DocumentValidationStatus | null;
            registrationDocument: DocumentValidationStatus | null;
        };
    }
): IStepList => {
    const documentCreated = params.kycInfo.identityProof === null || params.kycInfo.registrationDocument === null;
    const documentPartialPending =
        (params.kycInfo.identityProof !== null && params.kycInfo.registrationDocument === null) ||
        (params.kycInfo.identityProof === null && params.kycInfo.registrationDocument !== null);
    const documentPending =
        params.kycInfo.identityProof === DocumentValidationStatus.VALIDATION_ASKED ||
        params.kycInfo.registrationDocument === DocumentValidationStatus.VALIDATION_ASKED;
    const documentValidated =
        params.kycInfo.identityProof === DocumentValidationStatus.VALIDATED &&
        params.kycInfo.registrationDocument === DocumentValidationStatus.VALIDATED;
    const documentRefused =
        params.kycInfo.identityProof === DocumentValidationStatus.REFUSED ||
        params.kycInfo.registrationDocument === DocumentValidationStatus.REFUSED;

    return {
        1: {
            title: `${i18n.t('validation-step.extra.1-title', { lng: lang })}`,
            text: `${i18n.t('validation-step.extra.1-text', { lng: lang })}`,
            actions: {
                COMPLETE: {
                    isAvailable: validationStep === 1,
                    isDisabled: false,
                    title: `${i18n.t('validation-step.extra.1-actions-COMPLETE', { lng: lang })}`,
                },
            },
            isDone: validationStep > 1,
        },
        2: {
            title: `${i18n.t('validation-step.extra.2-title', { lng: lang })}`,
            text: documentCreated
                ? `${i18n.t('validation-step.extra.2-text-1', { lng: lang })}`
                : `${i18n.t('validation-step.extra.2-text-2', { lng: lang })}`,
            actions: {
                COMPLETE: {
                    isAvailable: validationStep === 2 || documentRefused || documentCreated,
                    isDisabled: validationStep === 1,
                    title: !documentRefused
                        ? `${i18n.t('validation-step.extra.2-actions-COMPLETE', { lng: lang })}`
                        : `${i18n.t('validation-step.extra.2-actions-COMPLETE-1', { lng: lang })}`,
                },
            },
            documentRefused,
            isDone: validationStep > 2 && !documentPartialPending && (documentValidated || documentPending),
        },
        3: {
            text: `${i18n.t('validation-step.extra.3-text', { lng: lang })}`,
            title: `${i18n.t('validation-step.extra.3-title', { lng: lang })}`,
            actions: {
                COMPLETE: {
                    isDisabled: validationStep !== 3 || !documentValidated,
                    title: `${i18n.t('validation-step.extra.3-actions-COMPLETE', { lng: lang })}`,
                    isAvailable:
                        (validationStep === 2 || validationStep === 3) && (documentValidated || documentPending),
                },
            },
            isDone: validationStep > 3,
        },
    } as any;
};

export type ExtraValidationStepsReturn = {
    getExtraValidationSteps: (
        validationStep: number,
        params: {
            kycInfo: {
                identityProof: DocumentValidationStatus;
                registrationDocument: DocumentValidationStatus;
            };
        }
    ) => IStepList;
};

export const extraValidationSteps = (_lang: string): ExtraValidationStepsReturn => {
    lang = _lang;
    return {
        getExtraValidationSteps,
    };
};
